//应付账款相关接口
import request from '@/axios/index.js'

// 应付账款列表
export function invoiceList(data) {
    return request.axios({
        type: "post",
        data: data,
        url: '/account/invoice/list'
    })
}

// 根据二维码获取发票信息
export function getQRCodeInfo(data, loading) {
    return request.axios({
        type: "post",
        data: data,
        loading: loading,
        noFailMsg: true,
        url: '/account/invoice/getQRCodeInfo'
    })
}

// 保存至发票列表
export function invoiceSave(data) {
    return request.axios({
        type: "post",
        data: data,
        url: '/account/invoice/save'
    })
}

// 发票详情
export function invGetById(data) {
    return request.axios({
        type: "post",
        data: data,
        url: '/account/invoice/getById'
    })
}

// 单据撤销
export function invDelete(data) {
    return request.axios({
        type: "post",
        data: data,
        url: '/account/invoice/delete'
    })
}

// 单据查验
export function go2Check(data, loading) {
    return request.axios({
        type: "post",
        data: data,
        loading: loading,
        url: '/account/invoice/go2Check'
    })
}

// 平台查验
export function go2PlatFormCheck(data, loading) {
    return request.axios({
        type: "post",
        data: data,
        loading: loading,
        url: '/account/invoice/go2PlatFormCheck'
    })
}

// 发票编辑
export function updateById(data, loading) {
    return request.axios({
        type: "post",
        data: data,
        loading: loading,
        url: '/account/invoice/updateById'
    })
}

// 根据键入卖方名称校验
export function selectSellerCstByName(data, loading) {
    return request.axios({
        type: "post",
        data: data,
        loading: loading,
        url: '/user/rcvbBuy/selectSellerCstByName'
    })
}

// 匹配合同
export function saveContractInfo(data, loading) {
    return request.axios({
        type: "post",
        data: data,
        loading: loading,
        url: '/account/invoice/saveContractInfo'
    })
}

// 匹配合同详情
export function getContractInfo(data, loading) {
    return request.axios({
        type: "post",
        data: data,
        loading: loading,
        url: '/account/invoice/getContractsByNo'
    })
}
// 解除匹配
export function deleteContractInfo(data, loading) {
    return request.axios({
        type: "post",
        data: data,
        loading: loading,
        url: '/account/invoice/deleteContractInfo'
    })
}
// 根据单据编号获取单据详情
export function getBaseAsset(data, loading) {
    return request.axios({
        type: "post",
        data: data,
        loading: loading,
        url: '/account/invoice/getBaseAsset'
    })
}
// 上传相关凭证
export function addVoucher(data, loading) {
    return request.axios({
        type: "post",
        data: data,
        loading: loading,
        url: '/account/invoice/addVoucher'
    })
}
// 查询相关凭证列表
export function getVoucherList(data, loading) {
    return request.axios({
        type: "post",
        data: data,
        loading: loading,
        url: '/account/invoice/getVoucherList'
    })
}
// 撤销相关凭证
export function deleteVoucherById(data, loading) {
    return request.axios({
        type: "post",
        data: data,
        loading: loading,
        url: '/account/invoice/deleteVoucherById'
    })
}
// 一级祺信查询贸易背景
export function queryGoldTradeBG(data, loading) {
    return request.axios({
        type: "post",
        data: data,
        loading: loading,
        url: '/fund/queryGoldTradeBG',
        contentType: 'application/json'
    })
}
// 融资时根据合同编号查询贸易背景
export function queryTradeBG(data, loading) {
    return request.axios({
        type: "post",
        data: data,
        loading: loading,
        url: '/fund/queryTradeBG',
        contentType: 'application/json'
    })
}

// 批量匹配凭证
export function addBatchVoucher(data, loading) {
    return request.axios({
        type: "post",
        data: data,
        loading: loading,
        url: '/account/invoice/addBatchVoucher'
    })
}
// 批量匹配凭证
export function getparamValue() {
    return request.axios({
        type: "get",
        url: '/user/communal/sys/param/DUE_DAYS'
    })
}
















// WEBPACK FOOTER //
// ./src/api/payable.js